import { Formik, Form } from "formik";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import RadioGroup from "../components/common/RadioGroup";

interface ModifierOptionFormProps {
  initialValues: any;
  validationSchema: any;
  onSubmit: (
    values: any,
    formikHelpers: {
      resetForm: () => void;
    }
  ) => Promise<void>;
  isLoading?: boolean;
}

const sectionTitleClasses = "mr-auto mt-4 text-primary font-semibold";
const vatOptions = [
  { label: "0%", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
];

const ModifierOptionForm: React.FC<ModifierOptionFormProps> = ({
  initialValues,
  validationSchema,
  onSubmit,
  isLoading,
}) => {
  return (
    <Formik
      initialValues={{
        ...initialValues,
        vatRatePercentage: initialValues.vatRatePercentage || 10,
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
        setFieldValue,
      }) => {
        return (
          <Form className="mx-auto w-3/5 flex flex-col items-center mt-12 gap-3">
            {/* Basic Info */}
            <TextField
              id="displayName"
              value={values.displayName}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Nom de l'option"
            />

            <TextField
              id="price"
              value={values.price}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Prix"
            />

            <RadioGroup
              label="Taux TVA (%)"
              options={vatOptions}
              value={values.vatRatePercentage}
              onChange={(val) =>
                setFieldValue("vatRatePercentage", Number(val))
              }
            />

            {/* Quantity Info */}
            <h3 className={sectionTitleClasses}>Quantité</h3>

            <TextField
              id="quantityInfo.minPermitted"
              value={values.quantityInfo.minPermitted}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Quantité minimale"
            />
            <TextField
              id="quantityInfo.maxPermitted"
              value={values.quantityInfo.maxPermitted}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Quantité maximale"
            />

            <h3 className={sectionTitleClasses}>Ordre d&apos;affichage</h3>
            <TextField
              id="displayOrder"
              value={values.displayOrder}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Ordre d'affichage"
            />

            <Button
              className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white mt-4"
              disabled={isSubmitting || isLoading}
              type="submit"
            >
              Enregistrer
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ModifierOptionForm;
